/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const CareerCenterFragment = {
  CareerCenter: gql`
    fragment CareerCenterQuery on careerCenter_Entry {
      careerCenterSideContent
      careerCenterTitle
      filterDefaultLabel
      filterTitle
      styles
      typeHandle
      warning
      careerCenterArticleCards {
        ... on careerCenterArticleCardsBlock_Entry {
          image {
            url
            ... on images_Asset {
              altText
            }
          }
          relatedResourceContent {
            html
          }
          relatedResourceLink
          relatedResourceCtaLabel
          careerCenterArticleCards {
            ... on careerCenterCategories_Category {
              aceCategoryCode
              title
            }
          }
        }
      }
    }
  `,
};
